<template>
  <div class="ma-0 pa-0" :class="isOnMobile ? 'box-container' : 'box-container-horizontal'" style="width: 100%; height: 100%" :style="isOnMobile ? 'flex-direction: column-reverse;' : ''">
    <div class="row-header ma-0 pa-0">
      <device-list class="ma-0 pa-0 px-1" :devices="getDevices" :width="isOnMobile ? '100%' : 270" :height="isOnMobile ? 300 : '100%'" :slotHeight="datatype && datatype.require_choice ? 40 : 0" @click="(dev) => devChanged(dev)"> </device-list>
    </div>
    <div v-if="dev" class="row-content ma-0 pa-0">
      <v-row class="ma-0 pa-0" justify="space-around">
        <span v-if="!isOnMobile" class="ma-2 pa-0">{{ TR.AutoReload }}</span>
        <v-progress-linear class="ma-1 mt-2 pa-0" :class="isOnMobile ? 'ma-1' : 'ma-2'" :value="((100 / reloadSeconds) * reloadValue) / reloadCoef" :height="5"></v-progress-linear>
      </v-row>
      <v-row class="ma-0 pa-0" justify="space-around">
        <v-card class="custom_hover_shadow pa-2" :class="isOnMobile ? 'ma-1' : 'ma-2'" elevation="3" :min-width="isOnMobile ? 320 : 400">
          <v-row v-if="!isOnMobile" class="pa-0" :class="isOnMobile ? 'ma-1' : 'ma-2'">
            <v-spacer></v-spacer>
            <span class="subtitle-1">{{ dev.Name }}</span>
            <v-spacer></v-spacer>
          </v-row>
          <v-row align="center" justify="center" class="pa-0" :class="isOnMobile ? 'ma-1' : 'ma-2'">
            <v-avatar size="44" tile>
              <v-img :src="dev.Image" width="auto" height="auto" contain></v-img>
            </v-avatar>
            <span>{{ dev.model.name }}</span>
            <v-spacer></v-spacer>
            <span>{{ TR.Status + ":" }}</span>
            <v-avatar>
              <v-icon :color="dev.Status.Color">{{ dev.Status.Icon }}</v-icon>
            </v-avatar>
            <span class="subtitle-2" :style="`color: ${dev.Status.Color}`">{{ dev.Status.Text }}</span>
          </v-row>
          <v-row class="pa-0" :class="isOnMobile ? 'ma-1' : 'ma-2'">
            <span>{{ TR.LastActivity + ": " }}</span>
            <v-spacer></v-spacer>
            <span>{{ dev.lastTalkDate ? dev.lastTalkDate.toTremolFpString() : "" }}</span>
          </v-row>
          <v-divider></v-divider>
          <v-row class="pa-0" :class="isOnMobile ? 'ma-1' : 'ma-2'">
            <span>{{ TR.SN + ":" }}</span>
            <v-spacer></v-spacer>
            <span>{{ dev.sn }}</span>
          </v-row>
          <v-divider></v-divider>
          <v-row class="pa-0" :class="isOnMobile ? 'ma-1' : 'ma-2'">
            <span>{{ TR.FMNum + ":" }}</span>
            <v-spacer></v-spacer>
            <span>{{ dev.LastReceipt.fm }}</span>
          </v-row>
          <v-divider></v-divider>
          <v-row class="pa-0" :class="isOnMobile ? 'ma-1' : 'ma-2'">
            <span>{{ TR.KLEN + ":" }}</span>
            <v-spacer></v-spacer>
            <span>{{ dev.LastReceipt.klen }}</span>
          </v-row>
          <v-divider></v-divider>
          <template v-if="dev.Address">
            <v-row class="pa-0" :class="isOnMobile ? 'ma-1' : 'ma-2'">
              <span class="caption">{{ dev.Address }}</span>
            </v-row>
            <v-divider></v-divider>
          </template>
          <template v-if="dev.PSName && !isOnMobile">
            <v-row class="pa-0" :class="isOnMobile ? 'ma-1' : 'ma-2'">
              <span>{{ TR.PSName + ": " }}</span>
              <v-spacer></v-spacer>
              <span>{{ dev.PSName }}</span>
            </v-row>
            <v-divider></v-divider>
          </template>
          <v-row v-if="dev.Technician" class="pa-0" :class="isOnMobile ? 'ma-1' : 'ma-2'">
            <span>{{ TR.Technician + ": " }}</span>
            <v-spacer></v-spacer>
            <span>{{ dev.Technician }}</span>
          </v-row>
          <v-divider v-if="!isOnMobile"></v-divider>
          <v-row v-if="!isOnMobile" class="pa-0" :class="isOnMobile ? 'ma-1' : 'ma-2'">
            <span>{{ TR.LastReceipt + ": " }}</span>
          </v-row>
          <v-row v-if="showReceipt && dev.LastReceipt" class="ma-0 pa-0" align="center" justify="center">
            <receipt-view :rec="dev.LastReceipt" :hideButtons="true" :hideDeviceInfo="true"></receipt-view>
          </v-row>
        </v-card>
      </v-row>
    </div>
    <div v-else class="row-content ma-0 pa-0" align="center" justify="center">
      <v-card-subtitle>{{ TR.PleaseChooseDevices }}</v-card-subtitle>
    </div>
  </div>
</template>

<script>
import { TR } from "../../main";
import DataManager, { ErrorMessage } from "../../js/DataManager";
import ReceiptView from "../Controls/ReceiptView.vue";

export default {
  components: {
    ReceiptView,
  },
  data() {
    return {
      datatype: null,
      devices: [],
      dev: null,
      error_message: null,
      title: "",
      TR: TR,
      reloadValue: 0,
      reloadCoef: 10,
      reloadSeconds: 20,
      showReceipt: true,
      fullCycle: false,
      reloadFN: () => {
        this.reloadValue++;
        if (this.reloadValue >= this.reloadSeconds * this.reloadCoef) {
          if (this.dev) {
            this.fullCycle = true;
            this.loadData();
          }
          this.reloadValue = 0;
        }
      },
      reloadInterval: null,
    };
  },
  computed: {
    getDevices() {
      return DataManager.getSubscribedDevs();
    },
  },
  methods: {
    refreshData() {
      this.devices = DataManager.getData(this.datatype);
    },
    setTitleAndData(meta, error) {
      this.datatype = meta.datatype;
      this.title = meta.title;
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.devices = DataManager.getData(this.datatype);
      } else {
        this.error_message = error.Message;
      }
    },
    loadData() {
      this.showReceipt = false;
      DataManager.loadData(
        DataManager.DataType.sales_last_only,
        () => {
          clearInterval(this.reloadInterval);
          this.reloadInterval = setInterval(this.reloadFN, 1000 / this.reloadCoef);
          this.showReceipt = true;
        },
        true,
        null,
        null,
        [this.dev]
      );
    },
    devChanged(item) {
      this.showReceipt = false;
      this.reloadValue = 0;
      this.dev = item;
      if (this.fullCycle) {
        this.fullCycle = false;
        this.loadData();
      } else {
        this.$nextTick(() => {
          this.showReceipt = true;
        });
      }
    },
    setFocus(on) {
      if (on) {
        this.reloadValue = 0;
        this.reloadInterval = setInterval(this.reloadFN, 1000 / this.reloadCoef);
      } else {
        clearInterval(this.reloadInterval);
      }
    },
  },
  mounted() {},
  created() {},
};
</script>